/**
 * Locations Block – Lazy-loaded Google Map
 *
 * • IntersectionObserver defers the ~200 KB Google Maps API until the
 *   map section is within 300 px of the viewport.
 * • Markers are read from a single `data-markers` JSON attribute
 *   (fewer DOM nodes than hidden .marker divs).
 * • The API key is passed from PHP via wp_localize_script.
 */
(function ($) {

    /* ── Dark-navy map styles ──────────────────────────────── */
    var darkStyle = [
        { elementType: "geometry",            stylers: [{ color: "#1a2e3b" }] },
        { elementType: "labels.text.fill",    stylers: [{ color: "#8ec3d8" }] },
        { elementType: "labels.text.stroke",  stylers: [{ color: "#1a2633" }] },
        { featureType: "administrative",      elementType: "geometry.stroke", stylers: [{ color: "#2a4a5a" }] },
        { featureType: "administrative.land_parcel", elementType: "labels.text.fill", stylers: [{ color: "#5a8a9a" }] },
        { featureType: "landscape",           elementType: "geometry", stylers: [{ color: "#1e3344" }] },
        { featureType: "poi",                 elementType: "geometry", stylers: [{ color: "#1e3344" }] },
        { featureType: "poi",                 elementType: "labels.text.fill", stylers: [{ color: "#6a9aaa" }] },
        { featureType: "poi.park",            elementType: "geometry.fill", stylers: [{ color: "#1a3040" }] },
        { featureType: "poi.park",            elementType: "labels.text.fill", stylers: [{ color: "#4a7a8a" }] },
        { featureType: "road",                elementType: "geometry", stylers: [{ color: "#243e4e" }] },
        { featureType: "road",                elementType: "geometry.stroke", stylers: [{ color: "#1a2e3b" }] },
        { featureType: "road",                elementType: "labels.text.fill", stylers: [{ color: "#6a9aaa" }] },
        { featureType: "road.highway",        elementType: "geometry", stylers: [{ color: "#2a4e5e" }] },
        { featureType: "road.highway",        elementType: "geometry.stroke", stylers: [{ color: "#1e3848" }] },
        { featureType: "road.highway",        elementType: "labels.text.fill", stylers: [{ color: "#8abaca" }] },
        { featureType: "transit",             elementType: "geometry", stylers: [{ color: "#1e3344" }] },
        { featureType: "transit.station",     elementType: "labels.text.fill", stylers: [{ color: "#6a9aaa" }] },
        { featureType: "water",               elementType: "geometry", stylers: [{ color: "#0e1e28" }] },
        { featureType: "water",               elementType: "labels.text.fill", stylers: [{ color: "#3a6a7a" }] },
    ];

    /* ── Marker SVG icon ───────────────────────────────────── */
    var markerSvg = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" width="30" height="40"><path fill="#3AAFDA" d="M0 188.6C0 84.4 86 0 192 0S384 84.4 384 188.6c0 119.3-120.2 262.3-170.4 316.8-11.8 12.8-31.5 12.8-43.3 0-50.2-54.5-170.4-197.5-170.4-316.8zM192 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"/></svg>';

    function getMarkerIcon() {
        return {
            url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(markerSvg),
            scaledSize: new google.maps.Size(30, 40),
            anchor:     new google.maps.Point(15, 40),
        };
    }

    /* ── Map helpers ───────────────────────────────────────── */
    function initMap($el) {
        // Read markers from JSON data attribute (no hidden DOM nodes)
        var markers = $el.data('markers') || [];
        var mapArgs = {
            zoom:             parseInt($el.data('zoom')) || 10,
            mapTypeId:        google.maps.MapTypeId.ROADMAP,
            styles:           darkStyle,
            disableDefaultUI: true,
            zoomControl:      true,
        };
        var map = new google.maps.Map($el[0], mapArgs);
        map.markers = [];

        markers.forEach(function (m) {
            addMarker(m, map);
        });

        centerMap(map);
        return map;
    }

    function addMarker(data, map) {
        var lat = parseFloat(data.lat);
        var lng = parseFloat(data.lng);
        if (isNaN(lat) || isNaN(lng)) return;

        var marker = new google.maps.Marker({
            position: new google.maps.LatLng(lat, lng),
            map:      map,
            icon:     getMarkerIcon(),
        });
        map.markers.push(marker);

        if (data.title || data.address) {
            var html = '';
            if (data.title)   html += '<p class="fw-semibold mb-1">' + data.title + '</p>';
            if (data.address) html += '<p class="mb-0 small">' + data.address + '</p>';
            var infowindow = new google.maps.InfoWindow({ content: html });
            google.maps.event.addListener(marker, 'click', function () {
                infowindow.open(map, marker);
            });
        }
    }

    function centerMap(map) {
        var bounds = new google.maps.LatLngBounds();
        $.each(map.markers, function (i, marker) {
            bounds.extend(new google.maps.LatLng(marker.position.lat(), marker.position.lng()));
        });
        if (map.markers.length === 1) {
            map.setCenter(bounds.getCenter());
            map.setZoom(parseInt(map.getDiv().dataset.zoom) || 10);
        } else {
            map.fitBounds(bounds);
        }
    }

    /* ── Initialise all .acf-map elements ──────────────────── */
    function initAllMaps() {
        $('.acf-map').each(function () {
            initMap($(this));
        });
    }

    /* ── Lazy-load Google Maps API via IntersectionObserver ── */
    var apiLoading = false;

    function loadGoogleMapsAPI() {
        if (apiLoading) return;
        apiLoading = true;

        // locationsMapData is wp_localize_script'd from PHP
        var apiKey = (typeof locationsMapData !== 'undefined') ? locationsMapData.apiKey : '';
        if (!apiKey) {
            console.warn('Locations block: Google Maps API key not found.');
            return;
        }

        var script  = document.createElement('script');
        script.src  = 'https://maps.googleapis.com/maps/api/js?key=' + apiKey + '&loading=async&callback=initACFMaps';
        script.async = true;
        script.defer = true;
        document.head.appendChild(script);
    }

    // Global callback invoked by the Maps API once ready
    window.initACFMaps = initAllMaps;

    /* ── Observe .acf-map entering near the viewport ───────── */
    $(function () {
        var maps = document.querySelectorAll('.acf-map');
        if (!maps.length) return;

        // Fallback for browsers without IntersectionObserver
        if (!('IntersectionObserver' in window)) {
            loadGoogleMapsAPI();
            return;
        }

        var observer = new IntersectionObserver(function (entries) {
            for (var i = 0; i < entries.length; i++) {
                if (entries[i].isIntersecting) {
                    loadGoogleMapsAPI();
                    observer.disconnect(); // Only need to trigger once
                    return;
                }
            }
        }, {
            rootMargin: '300px', // Start loading 300 px before visible
        });

        maps.forEach(function (el) {
            observer.observe(el);
        });
    });

})(jQuery);
